import script from "./TransferPromoCode.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferPromoCode.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QSlideTransition});
